import "./Social.css";

// light mode logos
import Github from "./assets/logoslight/GitHub.svg";
import LinkedIn from "./assets/logoslight/LinkedIn.svg";
import Mail from "./assets/logoslight/Mail.svg";
import Resume from "./assets/logoslight/Resume.svg";
import Twitter from "./assets/logoslight/Twitter.svg";

// dark mode logos
import GithubDark from "./assets/logosdark/GitHubDark.svg";
import TwitterDark from "./assets/logosdark/TwitterDark.svg";
import MailDark from "./assets/logosdark/MailDark.svg";
import LinkedInDark from "./assets/logosdark/LinkedInDark.svg";
import ResumeDark from "./assets/logosdark/ResumeDark.svg";

const Social = ({ dark }) => {
  return (
    <section className="socials">
      <div className="content">
        <div className="title">SOCIALS</div>
        <div className="linkcontainer">
          <a className="linkitem" href="https://github.com/viveknamaye">
            <img src={dark ? Github : GithubDark} alt="" />
            <p>GitHub</p>
          </a>
          <a className="linkitem" href="https://twitter.com/VivekNamaye">
            <img src={dark ? Twitter : TwitterDark} alt="" />
            <p>Twitter</p>
          </a>
          <a className="linkitem" href="mailto:namayevivek87@gmail.com">
            <img src={dark ? Mail : MailDark} alt="" />
            <p>Email</p>
          </a>
          <a
            className="linkitem"
            href="https://www.linkedin.com/in/viveknamaye/"
          >
            <img src={dark ? LinkedIn : LinkedInDark} alt="" />
            <p>LinkedIn</p>
          </a>
          <a className="linkitem" href="https://resume.namayevivek.com/">
            <img src={dark ? Resume : ResumeDark} alt="" />
            <p>Resume</p>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Social;
